import React from 'react'
import type { Icon } from 'shared/utils'

const Radio = (props: Icon) => {
    const {
        color = '#BB1E32',
        size = 24,
        className = 'radio',
        ...otherProps
    } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M19.059 4.917C15.147 1.018 8.815 1.029 4.917 4.94c-3.899 3.912-3.888 10.244.024 14.142a9.999 9.999 0 0 0 14.118 0c3.912-3.898 3.923-10.23.024-14.142a9.978 9.978 0 0 0-.024-.024zM16.784 9.2l-5.509 6.425-3.958-2.967a.833.833 0 0 1 1-1.333l2.708 2.033 4.492-5.241A.833.833 0 1 1 16.784 9.2z"
                fill={color}
            />
        </svg>
    )
}

export { Radio }
